import * as client from '../../services/client';
import { TYPES } from 'src/common/constants';
import { stopPRLoading, startPRLoading } from './loader';
import { setItemFormData } from './itemForm';

const fetchPropertiesDone = (payload) => ({
  type: TYPES.FETCH_PROPERTIES_DONE,
  payload,
});

export const fetchProperties = (userId, role, loader, type) => (dispatch) => {
  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }

  return client
    .getProperties(userId, role)
    .then((response) => {
      dispatch(stopPRLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            dispatch(fetchPropertiesDone(responsejson.data));
            if (type === 'add') {
              dispatch(
                setItemFormData({
                  selectedProperties:
                    responsejson.data && responsejson.data.length > 0
                      ? responsejson.data.map((pty) => ({
                          value: pty.id,
                          label: pty.name,
                        }))
                      : [],
                  isSelectAll: true,
                })
              );
            }
            dispatch(stopPRLoading());
          } else {
            dispatch(stopPRLoading());
          }
        });
      } else {
        // dispatch(stopLoading())
      }
    })
    .catch(() => {
      dispatch(stopPRLoading());
    });
};

export const fetchPropertyByIdDone = (payload) => ({
  type: TYPES.FETCH_PROPERTY_BY_ID_DONE,
  payload,
});

export const fetchPropertyById = (id) => (dispatch) => {
  return client.getPropertyById(id).then((response) => {
    if (response.status === '200' || response.ok) {
      response.json().then((responsejson) => {
        dispatch(fetchPropertyByIdDone(responsejson));
      });
    }
  });
};

export const fetchCountsDone = (payload) => ({
  type: TYPES.FETCH_COUNTS_DONE,
  payload,
});

export const clearCountsDone = () => ({
  type: TYPES.CLEAR_COUNTS_DONE,
});

export const fetchPropertyCounts = (propertyId, userId, role) => (dispatch) => {
  return client
    .fetchPropertyCounts(propertyId, userId, role)
    .then((response) => {
      if (response.status === 200 || response.ok) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            dispatch(fetchCountsDone(responsejson.data));
          }
        });
      }
    });
};
